import axios from 'axios'

export default {
  verifyEmail ( email, callback, fallback ) {
    axios.post('/auth/verify-email', { email })
    .then(resp => {
      if ( typeof callback == 'function' ) {
        callback( resp.data );
      }
    })
    .catch(() => {
      if ( typeof fallback == 'function' ) {
        fallback();
      }
    })
  },
  login ( loginAs, companyId, email, password, callback, fallback ) {
    axios.post('/auth/login', {
      login_as: loginAs,
      company_id: companyId,
      email, password
    })
    .then(resp => {
      if ( typeof callback == 'function' ) {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      }
    })
    .catch(error => {
      if ( typeof fallback == 'function' ) {
        if(typeof(fallback) != 'undefined') fallback( error );
      }
    })
  },
  logout: async () => {
    let { data } = await axios.post('/auth/logout');
    return data;
  },
}
